import useMethodStore from "@/store/MethodStore";
import useSettingsStore from "@/store/SettingsStore";
import { useCallback, useState } from "react";
import DockLaunchers from "./DockLaunchers";
import useDockStore from "@/store/dockStore";

function Dock() {

  const {
    notesState,
    calculatorState,
    paintState,
    settingsState,
    filesState,
    browserState,
    musicState,
    chatState,
  } = useMethodStore();
  const tempDynamicDock = useDockStore(state => state.tempDynamicDock)
  const dynamicDock = useSettingsStore(state => state.dynamicDock)

  const [isHovered, setIsHovered] = useState(dynamicDock || tempDynamicDock ? false : true);

  const getDockPosition = useCallback((): string => {

    if (tempDynamicDock) {
      if (!isHovered) {
        if ([paintState, filesState, browserState, settingsState].includes("maximized")) {
          return "bottom-0 lg:-bottom-20"
        }
      }
    }

    if (isHovered) {
      return "bottom-0 lg:bottom-4"
    }

    const floatingOrMinimized = [settingsState, filesState, paintState, chatState, notesState, calculatorState, browserState, musicState]

    // When dynamicDock is on
    if (
      !dynamicDock ||
      (floatingOrMinimized.includes("floating") ||
        floatingOrMinimized.includes("minimized"))
    ) {
      return "bottom-0 lg:bottom-4"; // Dock is shown dynamically
    }

    return "bottom-0 lg:-bottom-20"; // Default position (hidden)
  }, [tempDynamicDock, isHovered, settingsState, filesState, paintState, chatState, notesState, calculatorState, browserState, musicState, dynamicDock])

  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      onMouseEnter={() => (tempDynamicDock || dynamicDock) && setIsHovered(true)}
      onMouseLeave={() => (tempDynamicDock || dynamicDock) && setIsHovered(false)}
      className="fixed z-50 bottom-0 left-1/2 -translate-x-1/2 h-2 transition-all duration-300 w-full"
    >
      <div className={`absolute px-6 ${getDockPosition()} flex justify-center items-center transition-all duration-300 ease-in-out left-1/2 -translate-x-1/2 bg-zinc-900/80 backdrop-blur-sm w-full lg:w-fit lg:rounded-full`}>
        <DockLaunchers />
      </div>
    </div>
  )
}

export default Dock